import { inject, Injectable } from '@angular/core';
import { HelperRoutingService } from '@common/services/helper-routing.service';
import { HelperTimeService } from '@common/services/helper-time.service';

@Injectable({
  providedIn: 'root'
})
export class ValidateInputDayService {
  private readonly helpTime =       inject(HelperTimeService);
  private readonly helpRouting =    inject(HelperRoutingService);

  validateDayStringISOAndNavigate(
    stringDayISO:string,
    route:string[] = ['fichaje']
  ):string | undefined {
    // Valida el stringDayISO recibido en la route.
    // Si no es valido, navega a la ruta con la fecha de hoy.
    // Si es valido pero no es correcto (ej. 2025-02-30)
    // navega a la ruta con la fecha corregida (2025-03-02)
    const validStringDayISO = this.validateDayStringISO(stringDayISO);
    const today = this.helpTime.dateToStringDayISO(new Date());

    if(!validStringDayISO)
      this.helpRouting.navigateFullPath([...route, today]);
    if (validStringDayISO && validStringDayISO !== stringDayISO)
      this.helpRouting.navigateFullPath([...route, validStringDayISO]);
    return validStringDayISO;
  }

  validateDayStringISO(stringDayISO:string):string | undefined {
    // Retorna una fecha correcta en formato ISO (YYYY-MM-DD) (puede
    // NO ser la misma recibida) o undefined si no es valida.

    //? Validar formato ISO de fecha : '2025-05-28'
    //? Si no es valida, retornar undefined
    //? Si 'compila', pero no es correcta, (ej. 2025-02-30) devolver
    //? la fecha correcta (ej. 2025-03-02),

    if(!stringDayISO)return undefined;

    // validar estructura simple, digitos y guiones.
    const fechaRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!fechaRegex.test(stringDayISO))return undefined;

    // validar si la fecha 'compila' con .getTime(), o no es correcta
    let fechaAsDate = new Date(stringDayISO);
    if (isNaN(fechaAsDate.getTime()))return undefined;

    // validar si la fecha valida compilada, está escrita correctamente
    // de lo contrario, devuelve la fecha correctamente escrita
    const backToStringDayISO =  this.helpTime.dateToStringDayISO(fechaAsDate)
    if (stringDayISO !== backToStringDayISO){
      return backToStringDayISO;
    }
    return stringDayISO
  }

    navigateDayStringISOByOne(fecha: string, changeDay?: 'day++'|'day--') {
    if (!fecha || !this.validateDayStringISO(fecha))
      throw new Error('Fecha inválida');

    let dayAdd
    // if changeDay is not valid... keep same day
    switch (changeDay) {
      case 'day++':
        dayAdd = 1
        break;
      case 'day--':
        dayAdd = -1
        break;
      default:
        dayAdd = 0
        break;
    }

    let fechaBase = new Date(fecha);

    // change the day
    fechaBase.setDate(fechaBase.getDate() + dayAdd);

    const newStringDayISO = this.helpTime.dateToStringDayISO(fechaBase)
    this.helpRouting.navigateToSiblings(newStringDayISO)
  }
}
